import { EventsGetRequestParams } from "@lib/core";

export interface EventDefaultParams extends EventsGetRequestParams { }
export class EventDefaultParams {
  constructor() {
    this.select = "*";
    this.order = "id.asc";
  }
}